import { useCallback, useEffect, useRef, useState } from 'react';
import { getCookie, setCookie } from '../../../lib/cookies';
import { getOnboardingDetails, OnboardingType } from '../../../lib/onbording';
import { AUTO_LOGIN_TOOLTIP_DISMISSED_COOKIE_KEY } from '../constants';
export const useAutoLoginTooltip = (isAutoLoginEnabled) => {
    const [autoLoginState, setAutoLoginState] = useState();
    const shownTime = useRef(0);
    const dismissTime = useRef(0);
    // useEffect async
    const populateAutoLoginStatus = useCallback(async () => {
        if (!isAutoLoginEnabled) {
            return;
        }
        const { onboardingType, voucherEligibility } = await getOnboardingDetails();
        if (onboardingType !== OnboardingType.fashionStore || !voucherEligibility) {
            return;
        }
        /**
         * Mobile:  <NewsletterSubscriptionDialog /> just shows by user click on tooltip GOT IT button
         * Desktop: <NewsletterSubscriptionDialog /> shows automatically after 15s
         *
         * Design Document:
         * https://www.figma.com/file/Veo6gs3qZGDVmXrZKYv6r0/Autologin-A%2FB-test?node-id=1582%3A22783
         */
        const tooltipDismissed = getCookie(AUTO_LOGIN_TOOLTIP_DISMISSED_COOKIE_KEY) === 'true';
        if (tooltipDismissed) {
            // We basically set the dismiss time to the future to show the Dialog immediately
            dismissTime.current = Number.MAX_VALUE;
            setAutoLoginState('Dialog');
        }
        else {
            setAutoLoginState('Tooltip');
        }
    }, [isAutoLoginEnabled]);
    const handleAutoLoginTooltipDismiss = useCallback(() => {
        dismissTime.current = performance.now();
        setCookie(AUTO_LOGIN_TOOLTIP_DISMISSED_COOKIE_KEY, 'true');
        /**
         * Mobile: dismiss always happen by user(GOT IT) then we need to show <NewsletterSubscriptionDialog />
         *
         * Design Document:
         * https://www.figma.com/file/Veo6gs3qZGDVmXrZKYv6r0/Autologin-A%2FB-test?node-id=1582%3A22783
         */
        setAutoLoginState('Dialog');
    }, []);
    const handleAutoLoginTooltipShow = useCallback(() => {
        shownTime.current = performance.now();
    }, []);
    useEffect(() => {
        populateAutoLoginStatus();
    }, [populateAutoLoginStatus]);
    return {
        autoLoginState,
        handleAutoLoginTooltipDismiss,
        handleAutoLoginTooltipShow,
        delay: 15000 - (dismissTime.current - shownTime.current),
    };
};
//# sourceMappingURL=hook.js.map